// extracted by mini-css-extract-plugin
module.exports = {"container":"_1WJtG","tagLabel":"_3Mg8m"};